var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var eregStaffSelectWorkflowReviewTemplate = require('./eregStaffSelectWorkflowReviewTemplate.hbs');
var DemographicsDataBehavior = require('./../../demographics/DemographicsDataBehavior');
var AppointmentTypeDataBehavior = require('./../../appointment-type/AppointmentTypeDataBehavior');
var AppointmentTypeParentBehavior = require('./../../behaviors/AppointmentTypeParentBehavior');

/**
 * Staff select workflow view
 *
 * @class EregStaffSelectWorkflowReviewView
 * @constructor
 */
module.exports = TorsoView.extend({
  template: eregStaffSelectWorkflowReviewTemplate,

  behaviors: {
    demographics: {
      behavior: DemographicsDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: { property: '_patientVecnaId' }
    },
    appointmentTypeParentBehavior: AppointmentTypeParentBehavior,
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: function() {
        return _.map(this.view._appointmentModels, function(appointmentModel) {
          return appointmentModel.get('externalAppointment.type');
        });
      }
    },
    parentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointmentType.data:parentExternalId' }
    }
  },

  prepareFields: {
    workflowSteps: function() {
      return this._workflowFormModel && this._workflowFormModel.getAllWorkflowStepsStatus();
    },
    isCustomWorkflow: function() {
      return _.size(this._workflowFormModel && this._workflowFormModel.getDisabledWorkflowSteps()) !== 0;
    },
    appointmentLinesData: function() {
      var thisView = this;
      var appointmentTypeBehavior = this.getAppointmentTypeBehavior();
      return _.map(this._appointmentModels, function(appointmentModel) {
        var appointmentTime = appointmentModel.get('externalAppointment.time');
        var appointmentTypeId = appointmentModel.get('externalAppointment.type');
        var appointmentTypeModel = appointmentTypeId && appointmentTypeBehavior.data.getModel(appointmentTypeId);
        var serviceLevelAppointmentType = appointmentTypeId && thisView.getServiceLevelAppointmentType(appointmentTypeId);
        var visitLevelAppointmentTypeDisplayName = appointmentTypeModel && appointmentTypeModel.get('displayName');
        var serviceLevelAppointmentTypeDisplayName = serviceLevelAppointmentType && serviceLevelAppointmentType.get('displayName');
        if (visitLevelAppointmentTypeDisplayName === serviceLevelAppointmentTypeDisplayName) {
          serviceLevelAppointmentTypeDisplayName = null;
        }
        return {
          time: appointmentTime,
          visitLevelAppointmentTypeDisplayName: visitLevelAppointmentTypeDisplayName,
          serviceLevelAppointmentTypeDisplayName: serviceLevelAppointmentTypeDisplayName
        };
      });
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this view.
   *   @param [options.patientVecnaId] {String} Patient vecna id
   *   @param [options.workflowFormModel] {Model} the model containing the configuration of the steps for this appointment
   *   @param [options.appointmentModels] {AppointmentModel[]} the appointments on the review modal
   */
  initialize: function(options) {
    this._patientVecnaId = options.patientVecnaId;
    this._workflowFormModel = options.workflowFormModel;
    this._appointmentModels = options.appointmentModels;
  }
});
